import React from 'react';

import {
  type StatsTable as StatsTableType,
  type StatsTableColumn,
  type StatsTableRow } from
'~/components/BettingInsights/types';
import { StatsTable } from '~/components/OddscheckerPlus/components/cxy';

import styles from '../styles/Trends.module.css';

export type TrendType = 'last5' | 'last10' | 'last20';

export type TrendsStatsTableProps = {
  content: StatsTableType;
  formatDate: (date: string, format?: string) => string;
  length: number;
  trend: TrendType;
};

export const TrendsStatsTable = ({
  content,
  formatDate,
  length,
  trend
}: TrendsStatsTableProps) => {
  const PINNED_INDEX = 3;
  const columns = content.columns;
  const rows = content.rows.slice(0, Number(length));

  const columnTypes = columns.map((column: StatsTableColumn) => column.type);
  const columnAverages = columns.map(
    (column: StatsTableColumn) => column.average && column.average[trend]
  );

  const formatCell = ({
    index,
    value



  }: {index: number;value: string | number;}) => {
    const cellType = columnTypes[index];
    if (cellType === 'NUMBER' || cellType === 'STRING') {
      return value;
    }
    if (cellType === 'PERCENTAGE') {
      return `${value}%`;
    }

    return formatDate(`${value}`, 'MM/dd');
  };

  return (
    <StatsTable
      caption="Recent Performance"
      className={styles.statsTable}
      maxRows={10}>

			<StatsTable.Head>
				<StatsTable.Row>
					{columns.map((column, index) =>
          <StatsTable.Column
            justifyContent={index < PINNED_INDEX ? 'flex-start' : 'center'}
            key={`stats-table-${trend}-column-${index}`}
            pinned={index < PINNED_INDEX}>

							{column.value}
						</StatsTable.Column>
          )}
				</StatsTable.Row>
			</StatsTable.Head>

			<StatsTable.Body>
				{rows.map((row: StatsTableRow, rowIndex: number) =>
        <StatsTable.Row key={`stats-table-${trend}-row-${rowIndex}`}>
						{row.cells.map((cell, index) =>
          <StatsTable.Cell
            highlight={
            cell.betResult === 'WON' ?
            'green' :
            cell.betResult === 'LOST' ?
            'red' :
            undefined
            }
            justifyContent={index < 2 ? 'flex-start' : 'center'}
            key={`stats-table-${trend}-${rowIndex}-cell-${index}`}
            pinned={index < PINNED_INDEX}>

								{cell.value && formatCell({ value: cell.value, index })}
							</StatsTable.Cell>
          )}
					</StatsTable.Row>
        )}
			</StatsTable.Body>
			<StatsTable.Footer>
				<StatsTable.Row>
					{columnAverages.map((average, index) =>
          <React.Fragment key={`footer-cell-${trend}-${index}`}>
							{index === 0 ?
            <StatsTable.Column pinned scope="row">
									Average
								</StatsTable.Column> :

            <StatsTable.Cell
              justifyContent={index === 0 ? 'flex-start' : 'center'}
              pinned={index < PINNED_INDEX}>

									{average && formatCell({ value: average, index })}
								</StatsTable.Cell>
            }
						</React.Fragment>
          )}
				</StatsTable.Row>
			</StatsTable.Footer>
		</StatsTable>);

};